var module = angular.module('octopusApp.library');

module.directive('colorPicker', function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            color: '=',
            selectColor: '&onSelectColor'
        },
        templateUrl: 'areas/library/tagsets/views/color_picker.html',
        link: function (scope, element) {
        },
        controller: function ($scope) {
            $scope.colorSet1 = ['#983230', '#A77B22', '#227647', '#52818C', '#203A88', '#752BA5', '#6e6e6e'];
            $scope.colorSet2 = ['#E8634F', '#ECAD3F', '#36A766', '#77B7C5', '#3156B3', '#9786A7', '#9d9d9d'];
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/tagsets/controllers/color_picker.js
// module id = 470
// module chunks = 1